import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ServiceLinkComponent} from "./components/service-link/service-link.component";
import {ServicesTableComponent} from "./components/services-table/services-table.component";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {ServicesTableRowComponent} from "./components/services-table-row/services-table-row.component";
import {AccountsModule} from "../../account/angular/accounts.module";
import {ServiceInfoButtonComponent} from "./components/service-info-button/service-info-button.component";
import {ServicePriceDialogComponent} from "./components/service-price-dialog/service-price-dialog.component";
import {
  ServiceServiceAreasIndicationComponent
} from "./components/service-service-areas-indication/service-service-areas-indication.component";
import {ServiceProgressBarComponent} from "./components/service-progress-bar/service-progress-bar.component";
import {
  ServiceProgressTooltipComponent
} from "./components/service-progress-tooltip/service-progress-tooltip.component";
import {AgentsModule} from "../../agents/angular/agents.module";
import {
  BringozCountdownServiceAdapterComponent
} from "./components/bringoz-countdown-service-adapter/bringoz-countdown-service-adapter.component";
import {AddressesModule} from "../../addresses/angular/addresses.module";
import {ServiceTypeIndicationComponent} from "./components/service-type-indication/service-type-indication.component";
import {ServiceChatButtonComponent} from "./components/service-chat-button/service-chat-button.component";
import {
  ServiceSpotsIndicationComponent
} from "./components/service-spots-indication/service-spots-indication.component";
import {PackageSpotsPipe} from "../../commons/angular/pipes/package-spots.pipe";
import {
  ServiceAgentCommentIndicationComponent
} from "./components/service-agent-comment-indication/service-agent-comment-indication.component";
import {ServicesTableItemComponent} from "./components/services-table-item/services-table-item.component";
import {ServiceActionMenuComponent} from "./components/service-action-menu/service-action-menu.component";
import {ServiceTaskPodsComponent} from "./components/service-task-pods/service-task-pods.component";
import {LogisticsVehicleModule} from "../../logistics-vehicle/angular/logistics-vehicle.module";
import {ServicesPanelListComponent} from "./components/services-panel-list/services-panel-list.component";
import {ServicesTableListComponent} from "./components/services-table-list/services-table-list.component";
import {CdkDrag, DragDropModule} from "@angular/cdk/drag-drop";
import {ServicesPanelListItemComponent} from "./components/services-panel-list-item/services-panel-list-item.component";
import {ScrollingModule as ScrollingModuleExperimental} from "@angular/cdk-experimental/scrolling";
import {TasksModule} from "../../tasks/angular/tasks.module";


@NgModule({
  declarations: [
    ServiceLinkComponent,
    ServicesTableComponent,
    ServicesTableRowComponent,
    ServiceInfoButtonComponent,
    ServicePriceDialogComponent,
    ServiceServiceAreasIndicationComponent,
    ServiceProgressBarComponent,
    ServiceProgressTooltipComponent,
    BringozCountdownServiceAdapterComponent,
    ServiceTypeIndicationComponent,
    ServiceChatButtonComponent,
    ServiceSpotsIndicationComponent,
    ServiceAgentCommentIndicationComponent,
    ServicesTableItemComponent,
    ServiceActionMenuComponent,
    ServiceTaskPodsComponent,
    ServicesPanelListComponent,
    ServicesTableListComponent,
    ServicesPanelListItemComponent
  ],
  imports: [
    BrowserModule,
    CommonsModule,
    NgbModule,
    ScrollingModule,
    ScrollingModuleExperimental,
    AccountsModule,
    AgentsModule,
    LogisticsVehicleModule,
    AddressesModule,
    DragDropModule,
    TasksModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    CdkDrag
  ],
  exports: [
    ServiceLinkComponent,
    ServicesPanelListComponent,
    ServicesTableListComponent,
    ServicesPanelListItemComponent,
    ServiceTypeIndicationComponent
  ],
  providers: [
    PackageSpotsPipe
  ]
})

export class ServicesModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapServicesModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(ServicesModule);
};

export const downgradedServicesModule = downgradeModule(bootstrapServicesModule);
